import { useCMSPage } from "../../../context/CMSContext";

const DEFAULT_MEMBERS = [
  { name: "Tom Clarke", role: "Founder & MD",       image: "", bio: "Tom founded Cleario after one too many bad experiences with rogue traders." },
  { name: "Priya Shah",  role: "Operations Manager", image: "", bio: "Priya keeps the vans moving and the team on time." },
  { name: "Liam Baker",  role: "Head of Recycling",  image: "", bio: "Liam manages our processing partner network." },
];

export default function AboutTeam() {
  const { data: aboutCMS } = useCMSPage("about");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const teamCMS: any = (aboutCMS as any)?.team ?? {};

  const headline   = teamCMS?.headline    ?? "The people behind Cleario.";
  const subheadline= teamCMS?.subheadline ?? "A small, dedicated team that actually cares.";
  const members    = teamCMS?.members?.length ? teamCMS.members : DEFAULT_MEMBERS;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
            <span className="text-cl-dark text-xs font-black uppercase tracking-widest">The Team</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight mb-3">{headline}</h2>
          <p className="text-cl-dark/60 font-semibold text-base max-w-lg mx-auto">{subheadline}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {members.map((member: { name: string; role: string; image: string; bio: string }) => (
            <div key={member.name} className="bg-cl-tint rounded-2xl cartoon-card p-6 flex flex-col items-center text-center gap-4">
              <div className="w-20 h-20 rounded-full bg-cl-lime border-4 border-cl-dark cartoon-shadow-sm overflow-hidden flex items-center justify-center">
                {member.image
                  ? <img src={member.image} alt={member.name} className="w-full h-full object-cover" />
                  : <i className="ri-user-3-fill text-cl-dark text-4xl"></i>
                }
              </div>
              <div>
                <h3 className="font-black text-cl-dark text-lg leading-tight">{member.name}</h3>
                <p className="text-cl-green font-black text-xs uppercase tracking-widest mt-0.5 mb-2">{member.role}</p>
                <p className="text-cl-dark/65 text-sm font-semibold leading-relaxed">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
